import React, { useState } from 'react';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@material-ui/core';

// Components
import Button from 'components/Button';

// STyles
import styles from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BasicDialog = ({ classes, open, onClose, onSubmit, title, subtitle, leftButton = {}, rightButton = {} }) => {
    const [submitting, setSubmitting] = useState(false);
    const [input, setInput] = useState('');

    const handleClose = () => {
        if (!submitting && typeof onClose === 'function') onClose();
    };

    const handleSubmit = async () => {
        setSubmitting(true);
        if (typeof onSubmit === 'function') {
            try {
                await onSubmit(input);
                setSubmitting(false);
                setInput('');
            } catch (error) {
                /** Do nothing */
            }
        }
    };

    return (
        <Dialog
            open={open}
            classes={{ paper: classes.paper }}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description">
            <DialogTitle disableTypography classes={{ root: classes.title }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText classes={{ root: classes.subtitle }}>{subtitle}</DialogContentText>
            </DialogContent>
            <DialogActions classes={{ root: classes.actions }}>
                <Button
                    text="Cancel"
                    classes={{ root: classes.action }}
                    variantType="outlinedOutlinedGrey"
                    disabled={submitting}
                    onClick={handleClose}
                    {...leftButton}
                />
                <Button
                    variantType="containedOuterSpace"
                    classes={{ root: classes.action }}
                    onClick={handleSubmit}
                    loading={submitting}
                    text="Delete"
                    variant="contained"
                    {...rightButton}
                />
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(BasicDialog);
